import { path } from 'ramda';
import useRequest from './useRequest';
export const getHTMLBySelector = (cssSelector, data) => {
    const elt = document.createElement('div');
    elt.innerHTML = data;
    return path(['innerHTML'], elt.querySelector(cssSelector));
};
const useHTML = (endpoint, cssSelector, isManual) => {
    if (!endpoint) {
        return {
            data: '',
            isLoading: false,
        };
    }
    const { data, loading, error, execute, isRequestMade } = useRequest(endpoint, {
        use: {
            apiVersion: false,
        },
        manual: isManual,
    });
    return {
        data: cssSelector ? getHTMLBySelector(cssSelector, data) : data,
        isLoading: loading,
        error,
        fetchData: execute,
        isRequestMade,
    };
};
export default useHTML;
//# sourceMappingURL=useHTML.js.map